export default "__VITE_ASSET__CMTdFG1V__"